import React, { useState } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  TextField,
  Button,
  List,
  ListItem,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const FullScreenDialog = ({ open, handleClose }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const items = ["Item 1", "Item 2", "Item 3", "Another item"];
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredItems = items.filter((item) =>
    item.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <Dialog fullScreen open={open} onClose={handleClose}>
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
            sx={{ mr: 2 }}
          >
            <Close />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Check In Tickets
          </Typography>
          <TextField
            variant="outlined"
            placeholder="Search"
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{
              backgroundColor: "white",
              borderRadius: 1,
              width: isSmallScreen ? "100%" : "30%",
              ml: isSmallScreen ? 0 : 2,
              mr: isSmallScreen ? 0 : 2,
              mt: isSmallScreen ? 2 : 0,
            }}
            size="small"
          />
          {!isSmallScreen && (
            <>
              <Button color="inherit" onClick={() => {}}>
                Action 1
              </Button>
              <Button color="inherit" onClick={() => {}}>
                Action 2
              </Button>
            </>
          )}
        </Toolbar>
      </AppBar>

      <List>
        {filteredItems.map((item, index) => (
          <ListItem key={index}>{item}</ListItem>
        ))}
      </List>
    </Dialog>
  );
};

export default FullScreenDialog;
